<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <AdminSidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

        <!-- Table Card -->
        <v-card class="table-card mt-6">

          <div class="table-header d-flex justify-space-between align-center flex-wrap ga-3">
            <div class="d-flex align-center flex-wrap ga-3">
              <!-- Left side: search + clear -->
              <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 8px;">
                <InputText v-model="filters['global'].value" placeholder="Search Interest Type..." />
                <Button type="button" icon="pi pi-filter-slash" label="Clear" variant="outlined"
                  @click="clearFilters" />
              </div>
            </div>

            <!-- <v-btn variant="flat" prepend-icon="mdi-plus" class="theme-button" @click="feeConfigDialog = true">
              New Fee Config
            </v-btn> -->
            <button type="button" :disabled="loading" class="theme-button px-5"
              @click="resetForm(); isEditing = false; editingId = null; bannerDialog = true">
              <span v-if="!loading"><v-icon start>mdi-content-save-cog-outline</v-icon> Save Banner Details </span>
            </button>
          </div>
          <!-- PrimeVue DataTable with search ---NB: add showGridlines to show column lines-->
          <DataTable v-model:filters="filters" :value="banners" paginator :rows="10" dataKey="uuid" stripedRows
            class="modern-table" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem"
            filterDisplay="menu" selectionMode="single" :globalFilterFields="['title', 'link', 'call_to_action']">

            <!-- Empty table -->
            <template #empty>
              No Banner found.
            </template>

            <!-- Loading state -->
            <template #loading>
              Loading Banners...
            </template>

            <!-- Title Column -->
            <Column header="Title">
              <template #body="slotProps">
                {{ (slotProps.data.title) }}
              </template>
            </Column>

            <!-- Link Column -->
            <Column header="Web Deeplink URL">
              <template #body="slotProps">
                {{ slotProps.data.link }}
              </template>
            </Column>

            <!-- Call to action Column -->
            <!-- <Column header="Web External URL">
              <template #body="slotProps">
                {{ slotProps.data.call_to_action }}
              </template>
            </Column> -->

            <!-- Start Column -->
            <Column header="Start">
              <template #body="slotProps">
                {{ formatDate(slotProps.data.starts_at) }}
              </template>
            </Column>

            <!-- Call to action Column -->
            <!-- <Column header="Mobile External URL">
              <template #body="slotProps">
                {{ slotProps.data.mobile_external_url }}
              </template>
            </Column> -->

            <!-- Start Column -->
            <Column header="Mobile Deeplink URL">
              <template #body="slotProps">
                {{ slotProps.data.mobile_deeplink_url }}
              </template>
            </Column>

            <!-- End Column -->
            <Column header="Ends">
              <template #body="slotProps">
                {{ formatDate(slotProps.data.ends_at) }}
              </template>
            </Column>


            <!-- Actions Column -->
            <Column header="" style="width:120px; border-radius: 10px;">
              <template #body="slotProps">
                <v-menu>
                  <template #activator="{ props }">
                    <v-btn icon v-bind="props" variant="text">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openEditModal(slotProps.data)">
                      Edit {{ slotProps.data.title }} Details
                    </v-list-item>
                  </v-list>

                </v-menu>
              </template>
            </Column>

          </DataTable>
        </v-card>

        <!-- New Banner Modal -->
        <v-dialog v-model="bannerDialog" max-width="650">
          <v-card class="pa-6">

            <v-card-title class="text-h6 mb-4 text-center">
              {{ isEditing ? 'Edit Banner' : 'Create Banner' }}
            </v-card-title>

            <form @submit.prevent="handleSaveBanner" class="space-y-5">

              <!-- TITLE -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">Banner Title</label>
                <v-text-field v-model="bannerForm.title" variant="outlined" placeholder="Enter banner title" :rules="[
                  v => !!v || 'Title is required',
                  v => (v && v.length <= 255) || 'Maximum 255 characters'
                ]" />
              </div>

              <!-- IMAGE -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">
                  {{ isEditing ? 'Banner Image (optional)' : 'Banner Image' }}
                </label>

                <v-file-input v-model="bannerForm.image" variant="outlined" accept="image/*" prepend-icon="mdi-image"
                  show-size clearable @update:modelValue="previewImage" hint="Max file size: 5MB" persistent-hint />

                <v-img v-if="bannerPreview" :src="bannerPreview" max-height="200" cover class="rounded-lg border" />
              </div>


              <!-- LINK -->
              <!-- <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">Mobile External Link (Mobile External Link)</label>
                <v-text-field v-model="bannerForm.mobile_external_url" variant="outlined"
                  placeholder="https://example.com" :rules="[
                    v => !v || v.length <= 500 || 'Maximum 500 characters'
                  ]" />
              </div> -->

              <!-- CALL TO ACTION -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">Mobile Deeplink (Mobile Screen link)</label>
                <v-text-field v-model="bannerForm.mobile_deeplink_url" variant="outlined"
                  placeholder="e.g. Invest Now, Learn More" :rules="[
                    v => !v || v.length <= 500 || 'Maximum 500 characters'
                  ]" />
              </div>

              <!-- LINK -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">Link (Web External Link)</label>
                <v-text-field v-model="bannerForm.link" variant="outlined" placeholder="https://example.com" :rules="[
                  v => !v || v.length <= 500 || 'Maximum 500 characters'
                ]" />
              </div>

              <!-- CALL TO ACTION -->
              <!-- <div class="flex flex-col gap-2">
                <label class="text-sm font-medium">Call To Action (Web Screen)</label>
                <v-text-field v-model="bannerForm.call_to_action" variant="outlined"
                  placeholder="e.g. Invest Now, Learn More" :rules="[
                    v => !v || v.length <= 500 || 'Maximum 500 characters'
                  ]" />
              </div> -->

              <!-- START & END DATE -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                <div class="flex flex-col gap-2">
                  <label class="text-sm font-medium">Start Date</label>
                  <v-text-field v-model="bannerForm.starts_at" type="datetime-local" variant="outlined" />
                </div>

                <div class="flex flex-col gap-2">
                  <label class="text-sm font-medium">End Date</label>
                  <v-text-field v-model="bannerForm.ends_at" type="datetime-local" variant="outlined" />
                </div>

              </div>

              <!-- ACTIONS -->
              <div class="flex justify-center align-center gap-3 pt-4"
                style="display:flex; justify-content:center; align-items:center; gap:12px; padding-top:16px;">
                <v-btn variant="text" @click="bannerDialog = false">
                  Cancel
                </v-btn>

                <v-btn color="black" type="submit" :loading="bannerLoading" :disabled="!isBannerFormValid">
                  {{ isEditing ? 'Update Banner' : 'Save Banner' }}
                </v-btn>
              </div>

            </form>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
          snackbar.message }}
          <template #actions>
            <v-btn variant="outlined" @click="snackbar.show = false">
              Cancel
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import AdminSidebar from "@/components/AdminSidebar.vue"
import Header from "@/components/Header.vue"
import { bannerStore } from "@/store/banner"
import { formatDate, getAllErrors } from "@/util"
import { executeSaveBanner, executeUpdateBanner } from "@/api/banner"

const ban = bannerStore()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const filters = ref({ global: { value: null, matchMode: "contains" } })
const bannerDialog = ref(false)
const bannerLoading = ref(false)
//const bannerPreview = ref("");

const isEditing = ref(false)
const editingId = ref(null)

/* Mobile */
const toggleSidebar = () => {
  if (isMobile.value) drawerOpen.value = !drawerOpen.value
  else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

/* config */
const banners = computed(() => ban.banners || [])

/* Lifecycle */
onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  try {
    await ban.loadBanners()
  } catch (error) {
    console.error(error)
  }
})

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

/* Clear filters */
const clearFilters = () => {
  filters.value = { global: { value: null, matchMode: "contains" } }
}

const snackbar = ref({
  show: false,
  message: "",
  color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
  snackbar.value.message = message
  snackbar.value.color = color
  snackbar.value.show = true
}

const bannerPreview = computed(() => {
  if (bannerForm.value.image instanceof File) {
    return URL.createObjectURL(bannerForm.value.image)
  }
  return bannerForm.value.image || null // existing image URL in edit mode
})

const previewImage = (files) => {
  const file = Array.isArray(files) ? files[0] : files;

  if (!file) return;

  bannerPreview.value = URL.createObjectURL(file);
};

const bannerForm = ref({
  title: '',
  image: null,
  link: '',
  //call_to_action: '',
  //mobile_external_url: '',
  mobile_deeplink_url: '',
  starts_at: '',
  ends_at: ''
})

/**
 * FORM VALIDATION STATE
 */
const isBannerFormValid = computed(() => {
  return (
    bannerForm.value.title &&
    //bannerForm.value.mobile_external_url &&
    bannerForm.value.mobile_deeplink_url &&
    bannerForm.value.link &&
    //bannerForm.value.call_to_action &&
    bannerForm.value.starts_at &&
    bannerForm.value.ends_at
  )
})

/**
 * RESET FORM
 */
const resetForm = () => {
  bannerForm.value = {
    title: "",
    image: null,
    //mobile_external_url: "",
    mobile_deeplink_url: "",
    link: "",
    call_to_action: "",
    starts_at: "",
    ends_at: ""
  }
}

//editing modal
const openEditModal = (item) => {
  isEditing.value = true
  editingId.value = item.uuid

  bannerForm.value.title = item.title || ""
  bannerForm.value.link = item.link ?? ""
  //bannerForm.value.call_to_action = item.call_to_action || ""
  //bannerForm.value.mobile_external_url = item.mobile_external_url || ""
  bannerForm.value.mobile_deeplink_url = item.mobile_deeplink_url || ""
  bannerForm.value.starts_at = item.starts_at
    ? item.starts_at.replace(" ", "T").slice(0, 16)
    : "";

  bannerForm.value.ends_at = item.ends_at
    ? item.ends_at.replace(" ", "T").slice(0, 16)
    : "";
  bannerForm.value.image = null;
  console.log(item.image_url)

  bannerPreview.value = item.image;

  bannerDialog.value = true
}


//Function to create or edit
const handleSaveBanner = async () => {
  bannerLoading.value = true

  try {

    const payload = new FormData();

    payload.append("title", bannerForm.value.title);
    //payload.append("mobile_external_url", bannerForm.value.mobile_external_url ?? "");
    payload.append("mobile_deeplink_url", bannerForm.value.mobile_deeplink_url ?? "");
    payload.append("link", bannerForm.value.link ?? "");
    //payload.append("call_to_action", bannerForm.value.call_to_action ?? "");
    payload.append("starts_at", bannerForm.value.starts_at ?? "");
    payload.append("ends_at", bannerForm.value.ends_at ?? "");

    if (bannerForm.value.image instanceof File) {
      payload.append("image", bannerForm.value.image);
    }

    //await executeFeeConfig(payload)
    if (isEditing.value) {
      // update api
      await executeUpdateBanner(editingId.value, payload)
    } else {
      // create api
      await executeSaveBanner(payload)
    }

    showSnackbar("Banner updated successfully")
    bannerDialog.value = false

    // Reload list after success
    await ban.loadBanners()
  } catch (error) {
    const msg = getAllErrors(error)
    showSnackbar(
      msg || "Banner save error:",
      "error"
    )
    //console.error('Banner save error:', error.response?.data || error)
  } finally {
    bannerLoading.value = false
  }
}
</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background: #f8fafc;
}

/* Card */
.table-card {
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Table */
.modern-table {
  border: none;
}

/* Product */
.product-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.product-name {
  font-weight: 700;
}

.product-desc {
  font-size: 16px;
  color: #64748b;
}

/* Status */
.status-pill {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.status-active {
  background: #ecfdf5;
  color: #16a34a;
}

.status-inactive {
  background: #fef2f2;
  color: #dc2626;
}

/* Search input */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 8px;
  color: #64748b;
}

.search-wrapper input {
  padding-left: 28px;
}

/* Button */
.theme-button {
  height: 46px;
  background: #000;
  color: #fff;
  border-radius: 5px;
  font-weight: 600;
  transition: all 0.25s ease;
  margin: 0px;
}

.theme-button:hover {
  background: #292828;
}

.theme-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

.p-datatable-tbody>tr {
  cursor: pointer;
}

.p-datatable-tbody>tr:hover {
  background-color: #f5f5f5;
}
</style>
